module.exports = __webpack_public_path__ + "pc/img/award2020_03.c26ba908.png";